import React, { useState } from "react";
import PreRegisterForm from "components/Home/Preregister/PreRegisterForm";
import PreRegisterDetails from "components/Home/Preregister/PreRegisterDetails";
import { amountOptions } from "constants/amountOptions";
import { PreSigninStepsEnum } from "enum/common";
import { PreSigninSteps as steps } from "components/Home/Preregister/utils";

interface IPreRegisterModalProps {
  selectedBusiness: BusinessType;
  onCancel: () => void;
  setBusinessDetails: (isSilent: boolean) => void;
  setPreSignupHeader: (header: string) => void;
  setIsPreRegisterationSuccessfull: (value: boolean) => void;
}

const PreRegisterModal: React.FC<IPreRegisterModalProps> = ({
  onCancel,
  setBusinessDetails,
  selectedBusiness,
  setPreSignupHeader,
  setIsPreRegisterationSuccessfull,
}) => {
  const [topupAmount, setTopupAmount] = useState(amountOptions[0].value);
  const [errorMessage, setErrorMessage] = useState('');
  const [referralCode, setReferralCode] = useState(
    selectedBusiness?.preSignupDetails?.referralCode || selectedBusiness.usedReferralCode ||  ""
  );

  const [selectedStep, setSelectedStep] = useState(steps[0]);

  const onNext = () => {
    setSelectedStep(PreSigninStepsEnum.PreRegister);
    setPreSignupHeader("Card Details");
  };

  const onGoBack = () => {
    setSelectedStep(PreSigninStepsEnum.DETAIL);
    setPreSignupHeader("Pre-registration");
  };
  const onSuccess = () => {
    onCancel();
    setBusinessDetails(false);
  };

  const onCancelRegisteration = () => {
    onCancel();
    setBusinessDetails(false);
    setIsPreRegisterationSuccessfull(true);
  };

  const renderDetailsByStep = () => {
    switch (selectedStep) {
      case PreSigninStepsEnum.DETAIL:
        return (
          <>
            <PreRegisterDetails
              onNext={onNext}
              referralCode={referralCode}
              setReferralCode={setReferralCode}
              topupAmount={topupAmount}
              setTopupAmount={setTopupAmount}
              selectedBusiness={selectedBusiness}
              onCancelRegisteration={onCancelRegisteration}
              error={errorMessage}
              setErrorMessage={(message)=>setErrorMessage(message)}
            />
          </>
        );
      case PreSigninStepsEnum.PreRegister:
        return (
          <>
            <PreRegisterForm
              onGoBack={onGoBack}
              topupAmount={topupAmount}
              referralCode={referralCode}
              onSuccess={onSuccess}
              setErrorMessage={(message)=>setErrorMessage(message)}
            />
          </>
        );
    }
  };

  return (
    <div className="flex flex-col h-full flex-1">
      <div className="flex-1 gap-4 flex flex-col  items-center">
        {renderDetailsByStep()}
      </div>
    </div>
  );
};

export default PreRegisterModal;
